/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
export default function TabView({ tabs, initialTabId, onTabChange, navClassName = 'workspace__tabs nav', navLinkClassName = 'tabs__option', tabContentClassName = 'workspace__tab-container tab-content', activeTabClassName = 'active', activeNavLinkClassName = 'active' }) {
    const [activeTab, setActiveTab] = useState(() => {
        if (initialTabId)
            return initialTabId;
        return tabs.length > 0 ? tabs[0].id : '';
    });
    const handleTabClick = (tabId, e) => {
        e.preventDefault();
        setActiveTab(tabId);
        if (onTabChange) {
            onTabChange(tabId);
        }
    };
    if (!tabs || tabs.length === 0) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("ul", { className: navClassName }, tabs.map((tab) => (React.createElement("li", { key: tab.id, className: activeTab === tab.id ? activeNavLinkClassName : '' },
            React.createElement("a", { href: `#${tab.id}`, "data-toggle": "tab", className: navLinkClassName, onClick: (e) => handleTabClick(tab.id, e), "aria-current": activeTab === tab.id ? 'page' : undefined }, tab.label))))),
        React.createElement("div", { className: tabContentClassName }, tabs.map((tab) => (React.createElement("article", { key: tab.id, className: `workspace__tab-pane tab-pane ${activeTab === tab.id ? activeTabClassName : ''}`, id: tab.id, role: "tabpanel", hidden: activeTab !== tab.id }, activeTab === tab.id && tab.content))))));
}
